import { render, staticRenderFns } from "./GenericImage.vue?vue&type=template&id=5ca5f742"
import script from "./GenericImage.vue?vue&type=script&lang=js"
export * from "./GenericImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports